<template>
  <section class="tecnologies">
        <div class="container">
            <div class="row d-flex justify-content-center flex-column align-items-center">

                <h1 class="display-2 text-center mt-5">Tecnologías</h1>
                <p class="text-center mt-5 mb-5">Desarrollador Full Stack, enfoque backend-first. Construyo APIs y servicios con Django (Python), Go y Node, sobre PostgreSQL y MongoDB, cuidando migraciones, testing, logging y seguridad. En frontend, trabajo con Vue.js (HTML/CSS/JS) para interfaces rápidas, accesibles y responsive. Experiencia en módulos tipo ERP (créditos, reportes, dashboards) e integraciones con Odoo, n8n y bots de WhatsApp. Flujo sólido con Git y Bootstrap, orientado a despliegues listos para producción y soluciones elegantes y escalables.</p>
                <div class="col-18 col-lg-9 text-center">
                    <img src="/img/logos/python.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/vue.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/js.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/Go.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/node.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/aws.png" alt="" class="imgs-logos" style="height: auto;">
                    <!-- <img src="/img/logos/linux.svg" alt="" class="imgs-logos"> -->
                    <img src="/img/logos/n8n.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/postgres.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/mongo.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/java.svg" alt="" class="imgs-logos" style="height: auto; width: 60px;">
                    <img src="/img/logos/css.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/HTML5.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/Odoo.svg" alt="" class="imgs-logos" style="height: auto;">
                    <img src="/img/logos/bootstrap.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/figma.svg" alt="" class="imgs-logos">
                    <img src="/img/logos/illustrator.png" alt="" class="imgs-logos">
                    <img src="/img/logos/photoshop.svg" alt="" class="imgs-logos">
                </div>
                
            </div>
            
        </div>
</section>

</template>

<script>
export default {
    name: "TecnologiesStack",

}
</script>

<style>

</style>